import { render, staticRenderFns } from "./StocksItem.vue?vue&type=template&id=ad784e2c&"
import script from "./StocksItem.vue?vue&type=script&lang=js&"
export * from "./StocksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports